"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoModal = void 0;
const micromodal_1 = __importDefault(require("micromodal"));
const player_1 = __importDefault(require("@vimeo/player"));
const videoModal = () => {
    let iframe = document.querySelector('.modal__content iframe');
    if (!iframe) {
        return;
    }
    let source = iframe.src;
    micromodal_1.default.init({
        disableScroll: true,
        onShow: modal => {
            if (source.includes('vimeo')) {
                let player = new player_1.default(iframe);
                player.play();
            }
        },
        onClose: modal => {
            if (source.includes('vimeo')) {
                let player = new player_1.default(iframe);
                player.pause();
            }
        }
    });
};
exports.videoModal = videoModal;
